module.exports = __webpack_public_path__ + "media/cortina/guia-normalsobreviga-f7f8460f.png";